import React from "react";
import JobDetails from "../../views/FindJob/JobDetails";

const JobDetailsPage = () => {
  return <JobDetails />;
};

export default JobDetailsPage;
